import { Route, Switch, Redirect } from "react-router-dom";
import React, { Suspense } from "react";
import Layout from "./components/layout/Layout";
import AllQuotes from "./pages/AllQuotes";
// import NewQuote from "./pages/NewQuote";
import NoPageFounf from "./pages/NoPageFound";
import QuoteDetails from "./pages/QuoteDetails";
import LoadingSpinner from "./components/UI/LoadingSpinner";

//Use of lazy loading
const NewQuote = React.lazy(() => import("./pages/NewQuote"));

function App() {
  return (
    <div>
      <Layout>
        <Suspense
          fallback={
            <div className="centered">
              <LoadingSpinner />
            </div>
          }
        >
          <Switch>
            <Route path="/" exact>
              <Redirect to="/quotes" />
            </Route>
            <Route path="/quotes" exact>
              <AllQuotes />
            </Route>
            <Route path="/quotes/:quoteId">
              <QuoteDetails />
            </Route>
            <Route path="/new-quote">
              <NewQuote />
            </Route>
            <Route path="*">
              <NoPageFounf />
            </Route>
          </Switch>
        </Suspense>
      </Layout>
    </div>
  );
}

export default App;
